import type { Toast as ToastType, ToastType as ToastTypeEnum } from "./toast.service";
import { colors } from "@/theme/tokens/colors";

interface ToastProps {
  toast: ToastType;
  onRemove: (id: string) => void;
}

export const Toast = ({ toast, onRemove }: ToastProps) => {
  const getToastStyles = () => {
    const baseStyles: React.CSSProperties = {
      padding: "12px 16px",
      borderRadius: "8px",
      marginBottom: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      minWidth: "min(300px, 100%)",
      maxWidth: "min(500px, 100%)",
      width: "fit-content",
      pointerEvents: "auto",
      animation: "slideIn 0.3s ease-out",
    };

    const typeStyles: Record<ToastTypeEnum, React.CSSProperties> = {
      success: {
        backgroundColor: colors.success,
        color: "#ffffff",
      },
      error: {
        backgroundColor: colors.error,
        color: "#ffffff",
      },
      info: {
        backgroundColor: colors.info,
        color: "#ffffff",
      },
      warning: {
        backgroundColor: colors.warning,
        color: "#ffffff",
      },
    };

    return { ...baseStyles, ...typeStyles[toast.type] };
  };

  const renderIcon = () => {
    if (toast.type === "success") {
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginRight: "10px", flexShrink: 0 }}
          aria-hidden="true"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      );
    }
    if (toast.type === "error") {
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginRight: "10px", flexShrink: 0 }}
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      );
    }
    return null;
  };

  return (
    <div style={getToastStyles()}>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
        {renderIcon()}
        <span style={{ wordBreak: "break-word" }}>{toast.message}</span>
      </div>
      <button
        onClick={() => onRemove(toast.id)}
        style={{
          background: "transparent",
          border: "none",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: "18px",
          marginLeft: "12px",
          padding: "0 4px",
          lineHeight: 1,
        }}
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
};
